import { render, staticRenderFns } from "./FormElementIllustration.vue?vue&type=template&id=6d1c12bc&scoped=true&"
import script from "./FormElementIllustration.vue?vue&type=script&lang=js&"
export * from "./FormElementIllustration.vue?vue&type=script&lang=js&"
import style0 from "./FormElementIllustration.vue?vue&type=style&index=0&id=6d1c12bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c12bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
